import {
  Document,
  Text,
  Page,
  StyleSheet,
  Image,
  View,
} from "@react-pdf/renderer"
import frameAso from "./images/frame_asociart.png"
import { formatearNumero } from "../../../../modules/utils/formatearNumero.js"
import { formatearFechaLuxon } from "../../../../modules/utils/formatearFecha.js"
import { WEBURLEGALES } from "../../../helpers/frontend.js"

const styles = StyleSheet.create({
  page: {
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    paddingBottom: 40,
  },
  title: {
    fontSize: 12,
    textAlign: "right",
    color: "black",
    backgroundImage: `url("${WEBURLEGALES}/images/frame_asociart.png")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    marginTop: 20,
    marginRight: 20,
    height: 50,
  },
  section: {
    display: "flex",
    flexDirection: "row",
  },
  parragraph10: {
    fontSize: 10,
    textAlign: "left",
  },
  parragraphSub10: {
    fontSize: 10,
    textAlign: "right",
  },
  parragraph: {
    fontSize: 12,
    textAlign: "left",
    lineHeight: 1.5,
    margin: 10,
  },
  tableHeader: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 10,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  row: {
    flexDirection: "row",
    alignItems: "stretch",
  },
  header: {

  },
  cell: {
    flex: 1,
    padding: 8,
    fontSize: 10,
  },
  cell1: {
    flex: 1,
    padding: 8,
    fontSize: 12,
    borderBottom: "4px solid #c60c30",
  },
  cell2: {
    flex: 1,
    padding: 8,
    fontSize: 10,
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
  },
  cell3: {
    flex: 1,
    padding: 8,
    fontSize: 9,
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
    borderBottom: "1px solid gray",
  },
  cell4: {
    flex: 1,
    padding: 8,
    fontSize: 8,
    textAlign: "center",
    backgroundColor: "#E4E4E4",
    border: "1px solid gray",
  },
  cell5: {
    flex: 1,
    padding: 8,
    fontSize: 10,
  },
  cell6: {
    flex: 1,
    padding: 8,
    fontSize: 10,
    marginRight: 3
  },
  separacion: {
    height: "100px",
  },
  firmas: {
    width: "100%",
    textAlign: "center",
  },
  pageBackground: {
    position: "absolute",
    minWidth: "100%",
    minHeight: "100%",
    display: "block",
    height: "100%",
    width: "100%",
  },
  footer: {
    position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "left",
    fontSize: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 10,
  },
  pageNumber: {
    fontSize: 10,
  },  
  cellCabeceraTabla:{    
    textAlign: "center",
    backgroundColor: "#E4E4E4",
  },
  cellFecha: {
    flex: 1,
    padding: 8,
    fontSize: 9,
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
    borderBottom: "1px solid gray",
    width: 200,
  },
  cellHistoria: {
    flex: 1,
    padding: 8,
    fontSize: 9,
    borderLeft: "1px solid gray",
    borderRight: "1px solid gray",
    borderBottom: "1px solid gray",
    width: 700,
  },
});

function ImprimirPDFAntecedentes({ datosImpresion }) {
  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.pageBackground}>
          <Image src={frameAso} />
        </View>
        <Text style={[styles.title, { fontFamily: "Helvetica-Bold" }]}>
          ANTECEDENTES SINIESTRALES
        </Text>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              SINIESTRO
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Nro Siniestro: </Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.nroSiniestro}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Canal de Ingreso:</Text>

            </Text>
          </View>
        </View>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              TRABAJADOR
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Nombre y Apellido:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.trabajador.nombreApellido}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>Cuil:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.trabajador.cuil}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fecha de Nacimiento:</Text>
              <Text>{datosImpresion.trabajador.fechaNacimiento}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>
                Condición Nomina:
              </Text>
              <Text style={[styles.cell6]}> {datosImpresion.trabajador.condicionNomina}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Edad:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.trabajador.edad}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>
                IBM:
              </Text>
              <Text style={[styles.cell6]}> {formatearNumero(datosImpresion.trabajador.ibm)}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              EMPLEADOR - Datos de Cobertura
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Razón Social:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.razonSocial}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>CUIT:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.cuit}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Nro. Contrato:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.intNroContrato}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>Vigente:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.vigencia}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fechas de Vigencia:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.fechaAltaContrato} / {datosImpresion.empleador.fechaBajaContrato ? datosImpresion.empleador.fechaBajaContrato : '--'}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Cobertura del Trabajador:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.fechaAltaCoberturaTrabajador} / {datosImpresion.empleador.fechaBajaCoberturaTrabajador ? datosImpresion.empleador.fechaBajaCoberturaTrabajador : '--'}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Accidente
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Tipo de Accidente:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.chrTipoSiniestro}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>Estado de Siniestro:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.estadoSiniestro}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fecha de Accidente:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.fechaAccidente}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fecha de Alta Medica:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.fechaAltaMedica}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>Origen del Accidente:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.origenAccidente}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Descripción del Accidente:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.descripcion}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>CIE10:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.ciE10}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Crónico:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.cronico}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>Recalificación:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.recalificacion}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Otros siniestros del mismo trabajador:</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Siniestro</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>F. Accidente</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Tipo siniestro</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Incapacidad</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>OMS/CIE10</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Empleador</Text>
            </Text>
          </View>
        </View>
        {datosImpresion.anterioresSiniestros.length > 0 &&
          datosImpresion.anterioresSiniestros.map((siniestro, index) => (
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{siniestro.nroSiniestro}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{siniestro.fechaAccidente}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{siniestro.tipoSiniestro}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{siniestro.incapacidad}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{siniestro.cIE10}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{siniestro.empleador}</Text>
                </Text>
              </View>
            </View>
          ))}
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Reclamos previos contra Asociart ART
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Nro. de Siniestro:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fecha de notificación:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Carátula:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>N° de expediente judicial:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Juzgado:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Jurisdicción:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Tipo de Reclamo:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Conciliación:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Estado:</Text>
              <Text style={[styles.cell6]}>  </Text>
            </Text>
          </View>
        </View>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Remuneración IBM
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Siniestro:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.accidentes.nroSiniestro}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>Trabajador:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.trabajador.nombreApellido}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>CUIL:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.trabajador.cuil}</Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fecha de ingreso a la empresa:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.fechaAltaCoberturaTrabajador}</Text>
            </Text>
          </View>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fin de contrato laboral:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.fechaBajaContrato ? "SI" : "NO"}</Text>
            </Text>
            <Text style={[styles.cell, styles.header]}>
              <Text>Fecha de Fin:</Text>
              <Text style={[styles.cell6]}> {datosImpresion.empleador.fechaBajaContrato && datosImpresion.empleador.fechaBajaContrato}</Text>
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Orden</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Periodo</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>DDJJ</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Detalle DDJJ</Text>
            </Text>
          </View>
        </View>
        {datosImpresion.remuneracionIBM.length > 0 &&
          datosImpresion.remuneracionIBM.map((ibm, index) => (
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{ibm.orden}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{ibm.periodo}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{formatearNumero(ibm.ddjj)}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{ibm.detalleDDJJ}</Text>
                </Text>
              </View>
            </View>
          ))}
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Total Ingresos:</Text>
            <Text style={[styles.cell6]}> {formatearNumero(datosImpresion.historialCalculoIBM.totalIngresos)}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>REMUNERACIÓN TOTAL:</Text>
            <Text style={[styles.cell6]}> {formatearNumero(datosImpresion.historialCalculoIBM.totalIngresos)}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>Total Período:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.historialCalculoIBM.totalPeriodo}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>IBM:</Text>
            <Text style={[styles.cell6]}> {formatearNumero(datosImpresion.historialCalculoIBM.ingresoBaseMensual)}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>IBM RIPTE:</Text>
            <Text style={[styles.cell6]}> {formatearNumero(datosImpresion.historialCalculoIBM.imbRipte)}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>SAC Devengado:</Text>
            <Text style={[styles.cell6]}> {formatearNumero(datosImpresion.historialCalculoIBM.monSACDevengado)}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>IBM RIPTE controlado:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.historialCalculoIBM.ripteControlado}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>3er SAC:</Text>
            <Text style={[styles.cell6]}> {formatearNumero(datosImpresion.historialCalculoIBM.monTercerSac)}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>DDJJ Controlado:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.historialCalculoIBM.controlado}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Observaciones:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.historialCalculoIBM.observaciones}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>DDJJ Controlado SRT:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.historialCalculoIBM.controladoDDJJ}</Text>
          </Text>
        </View>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Datos AA / Audiencia / Dictámenes
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>N° Expediente</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Tipo Presentación</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Ente</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha AA</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha Toma Conocimiento</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Porcentaje</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Homologado</Text>
            </Text>
          </View>
        </View>
        {datosImpresion.expedientesReporte.length > 0 &&
          datosImpresion.expedientesReporte.map((expediente, index) => (
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{expediente.nroExpediente}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{expediente.tipoPresentacion}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{expediente.ente}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{expediente.fecha}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{expediente.fechaTomaConoc}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{expediente.porcentaje}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{expediente.homologado}</Text>
                </Text>
              </View>
            </View>
          ))}
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Acta Acuerdo
            </Text>
          </View>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Fecha Acta Acuerdo:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.actaAcuerdo.fechaActaAcuerdo}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>Porcentaje Acta Acuerdo:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.actaAcuerdo.porcentajeActa}</Text>
          </Text>
        </View>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Comisión Médica
            </Text>
          </View>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Fecha Audiencias:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.fechaAudiencia}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>Nro. Expediente:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.expediente}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Tipo Presentación:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.tipoPresentacion}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>Ente:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.ente}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Fecha Dictamen:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.fechaDictamen}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>Fecha Toma Conocimiento:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.fechaTomaConocimiento}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Fecha Accidente Dictamen:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.fechaAccidenteDictamen}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>% Incapacidad Ente Dictaminador:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.incaEnte}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Contingencia segun Dictamen:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.contingencia}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Caracter:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.caracter}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>Tipo:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.tipoPresentacion}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Grado Incapacidad:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.tipoIncapacidad}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Continua Presentaciones:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.continuacionPrestacion}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Homologado:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.homologado}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Recalificacion Laboral:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.racalificiacionLaboral}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Gran Invalido:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.granInvalido}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Motivo de la Intervención:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.motivosIntervencion}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Apelado ART:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.apeladoART}</Text>
          </Text>
          <Text style={[styles.cell, styles.header]}>
            <Text>Apelado Trabajador:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.apeladoTrabajador}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Observaciones:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.observaciones}</Text>
          </Text>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Observaciones continua Prestaciones:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.comisionMedica.observacionPrestaciones}</Text>
          </Text>
        </View>
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Incapacidad
            </Text>
          </View>
        </View>
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Recibo:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.detallesIncapacidad.recibo}</Text>
          </Text>
        </View>     
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Fecha de Pago:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.detallesIncapacidad.fechaPago}</Text>
          </Text>
        </View> 
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>concepto:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.detallesIncapacidad.concepto}</Text>
          </Text>
        </View> 
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Monto:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.detallesIncapacidad.monMonto}</Text>
          </Text>
        </View> 
        <View style={[styles.row, styles.header]}>
          <Text style={[styles.cell, styles.header]}>
            <Text>Estado:</Text>
            <Text style={[styles.cell6]}> {datosImpresion.detallesIncapacidad.estado}</Text>
          </Text>
        </View>  
        <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Evoluciones Médicas
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header, styles.cellCabeceraTabla]}>
            <Text style={[styles.cellFecha, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha</Text>
            </Text>
            <Text style={[styles.cellHistoria, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Historia</Text>
            </Text>
          </View>
        </View>
        {datosImpresion.historiaClinica.length > 0 &&
          datosImpresion.historiaClinica.map((historia, index) => (
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cellFecha, styles.header]}>
                  <Text>{formatearFechaLuxon(historia.fecha,"dd/MM/yyyy hh:mm a")}</Text>
                </Text>
                <Text style={[styles.cellHistoria, styles.header]}>
                  <Text>{historia.historia}</Text>
                </Text>
              </View>
            </View>
          ))}          
          <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Datos Observaciones Siniestro
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Observaciones</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Usuario</Text>
            </Text>
          </View>
        </View>
        {datosImpresion.observacionesDenuncia.length > 0 &&
          datosImpresion.observacionesDenuncia.map((obs, index) => (
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell3, styles.header]}>
                <Text>{formatearFechaLuxon(obs.datFechaAlta,"dd/MM/yyyy hh:mm a")}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{obs.varObservaciones}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{obs.varNombreCompleto}</Text>
                </Text>
              </View>
            </View>
          ))}     
  <View style={styles.tableHeader}>
          <View style={[styles.row]}>
            <Text
              style={[
                styles.cell1,
                styles.boldText,
                { fontFamily: "Helvetica-Bold" },
              ]}
            >
              Seguimiento de Cartas
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.header]}>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha generación</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha de Envío</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Fecha Novedad</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Cod. Seg.</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Estado</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>AUT</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>AR</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Modelo de Carta</Text>
            </Text>
            <Text style={[styles.cell4, styles.header]}>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Lote</Text>
            </Text>

          </View>
        </View>
        {datosImpresion.cartasEnviadas.length > 0 &&
          datosImpresion.cartasEnviadas.map((carta, index) => (
            <View style={styles.table}>
              <View style={[styles.row, styles.header]}>
                <Text style={[styles.cell3, styles.header]}>
                <Text>{carta.fechaGeneracion}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{carta.fechaEnvio}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{carta.fechaNovedad}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                <Text>{carta.codSeguimiento}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{carta.estado}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{carta.aut}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                <Text>{carta.ar}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{carta.modelo}</Text>
                </Text>
                <Text style={[styles.cell3, styles.header]}>
                  <Text>{carta.lote}</Text>
                </Text>                                
              </View>
            </View>
          ))}                                                   
      </Page>
    </Document>
  );
}

export default ImprimirPDFAntecedentes
